// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-wrapper {
    margin: 50px auto;
    width: 280px;
    height: 370px;
    background: white;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 8px rgba(0,0,0,0.3);
    -moz-box-shadow:    0px 0px 8px rgba(0,0,0,0.3);
    box-shadow:         0px 0px 8px rgba(0,0,0,0.3);
    position: relative;
    z-index: 90;
  }
  
  .ribbon-wrapper {
    width: 85px;
    height: 26px;
    overflow: hidden;
    position: absolute;
    top: -1px;
    /* right: -3px; */
    pointer-events: none;
  }
  
  .ribbon {
    font: bold 15px Sans-Serif;
    color: #333;
    text-align: center;
    text-shadow: rgba(255,255,255,0.5) 0px 1px 0px;
    -webkit-transform: rotate(135deg);
    -moz-transform:    rotate(135deg);
    -ms-transform:     rotate(135deg);
    -o-transform:      rotate(135deg);
    position: relative;
    padding: 3px 0;
    left: -8px;
    top: 6px;
    width: 40px;
   
    /* background-image: -webkit-gradient(linear, left top, left bottom, from(#BFDC7A), to(#8EBF45)); 
    background-image: -webkit-linear-gradient(top, #BFDC7A, #8EBF45); 
    background-image:    -moz-linear-gradient(top, #BFDC7A, #8EBF45); 
    background-image:     -ms-linear-gradient(top, #BFDC7A, #8EBF45); 
    background-image:      -o-linear-gradient(top, #BFDC7A, #8EBF45);  */
    color: #6a6340;
    -webkit-box-shadow: 0px 0px 3px rgba(0,0,0,0.3);
    -moz-box-shadow:    0px 0px 3px rgba(0,0,0,0.3);
    box-shadow:         0px 0px 3px rgba(0,0,0,0.3);
  }
  
  .ribbon:before, .ribbon-green:after {
    content: "";
    border-top:   3px solid #6e8900;   
    border-left:  3px solid transparent;
    border-right: 3px solid transparent;
    position:absolute;
    bottom: -3px;
  }
  
  .ribbon:before {
    left: 0;
  }
  
  .ribbon:after {
    left: 0;
  }
`, "",{"version":3,"sources":["webpack://./logician_coder/static/css/corner-ribbon.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,8CAA8C;IAC9C,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,WAAW;;IAEX;;;;wEAIoE;IACpE,cAAc;IACd,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,mCAAmC;IACnC,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT","sourcesContent":[".item-wrapper {\n    margin: 50px auto;\n    width: 280px;\n    height: 370px;\n    background: white;\n    border-radius: 10px;\n    -webkit-box-shadow: 0px 0px 8px rgba(0,0,0,0.3);\n    -moz-box-shadow:    0px 0px 8px rgba(0,0,0,0.3);\n    box-shadow:         0px 0px 8px rgba(0,0,0,0.3);\n    position: relative;\n    z-index: 90;\n  }\n  \n  .ribbon-wrapper {\n    width: 85px;\n    height: 26px;\n    overflow: hidden;\n    position: absolute;\n    top: -1px;\n    /* right: -3px; */\n    pointer-events: none;\n  }\n  \n  .ribbon {\n    font: bold 15px Sans-Serif;\n    color: #333;\n    text-align: center;\n    text-shadow: rgba(255,255,255,0.5) 0px 1px 0px;\n    -webkit-transform: rotate(135deg);\n    -moz-transform:    rotate(135deg);\n    -ms-transform:     rotate(135deg);\n    -o-transform:      rotate(135deg);\n    position: relative;\n    padding: 3px 0;\n    left: -8px;\n    top: 6px;\n    width: 40px;\n   \n    /* background-image: -webkit-gradient(linear, left top, left bottom, from(#BFDC7A), to(#8EBF45)); \n    background-image: -webkit-linear-gradient(top, #BFDC7A, #8EBF45); \n    background-image:    -moz-linear-gradient(top, #BFDC7A, #8EBF45); \n    background-image:     -ms-linear-gradient(top, #BFDC7A, #8EBF45); \n    background-image:      -o-linear-gradient(top, #BFDC7A, #8EBF45);  */\n    color: #6a6340;\n    -webkit-box-shadow: 0px 0px 3px rgba(0,0,0,0.3);\n    -moz-box-shadow:    0px 0px 3px rgba(0,0,0,0.3);\n    box-shadow:         0px 0px 3px rgba(0,0,0,0.3);\n  }\n  \n  .ribbon:before, .ribbon-green:after {\n    content: \"\";\n    border-top:   3px solid #6e8900;   \n    border-left:  3px solid transparent;\n    border-right: 3px solid transparent;\n    position:absolute;\n    bottom: -3px;\n  }\n  \n  .ribbon:before {\n    left: 0;\n  }\n  \n  .ribbon:after {\n    left: 0;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
